import { useQuery } from "@tanstack/react-query";
import { Card, Container, Header, Loader, Segment } from "semantic-ui-react";
import { getInsights } from "../api/insights";
import StatCard from "../components/StatCard";
import useCallInsights from "../hooks/useCallInsights";

export const colours = {
  teal: "#58b9b7",
  violet: "#98a0d9",
  purple: "#ca98d9",
  blue: "#98b6d9",
  green: "#5cb958",
  red: "#e85858",
};

function Insights() {
  const { callInsights, getUpdatedAt } = useCallInsights();

  const insightsQuery = useQuery(
    ["insights"],
    () => {
      return getInsights();
    },
    {
      keepPreviousData: true,
      cacheTime: 3600000, // one hour
      staleTime: 600000, // 10 mins
    },
  );

  return (
    <Container>
      <Segment basic>
        <h1>Insights</h1>
        <Header>Calls</Header>
        <Card.Group>
          <StatCard
            label="Recent calls"
            value={callInsights?.count}
            colour={colours.purple}
            loading={!callInsights}
            help="Up to a maximum of 1000"
          />
          <StatCard
            label="Average Talk Time"
            value={callInsights?.average_duration}
            colour={colours.purple}
            loading={!callInsights}
            help="Displayed as minutes;seconds"
          />
          <StatCard
            label="Total Talk Time"
            value={callInsights?.total_duration}
            colour={colours.purple}
            loading={!callInsights}
            help="Displayed as minutes;seconds"
          />
          <StatCard
            label="Recent Outgoing Calls"
            value={callInsights?.outgoing?.count}
            colour={colours.violet}
            loading={!callInsights}
          />
          <StatCard
            label="Recent Outgoing %"
            value={callInsights?.outgoing?.percent}
            colour={colours.violet}
            loading={!callInsights}
          />
        </Card.Group>
        <Card.Group>
          <StatCard
            label="Recent Incoming Calls"
            value={callInsights?.incoming?.count}
            colour={colours.teal}
            loading={!callInsights}
          />
          <StatCard
            label="Recent Incoming %"
            value={callInsights?.incoming?.percent}
            colour={colours.teal}
            loading={!callInsights}
          />
        </Card.Group>
        <Header>Calendar</Header>
        <Card.Group>
          <StatCard
            label="Events This Week"
            value={insightsQuery.data?.data?.data.events.count}
            colour={colours.purple}
            loading={insightsQuery.isFetching}
          />
          <StatCard
            label="Time in Events"
            value={insightsQuery.data?.data?.data.events.busy_time}
            colour={colours.purple}
            loading={insightsQuery.isFetching}
          />
          <StatCard
            label="Time in Events"
            value={`${insightsQuery.data?.data?.data.events.busy_percent}%`}
            colour={colours.purple}
            loading={insightsQuery.isFetching}
          />
        </Card.Group>

        <div style={{ marginTop: "12px" }}>
          <small>
            Looking at busy events Monday to Friday, between 9am and 5pm.
          </small>
        </div>

        {insightsQuery.data?.data?.data.hasOwnProperty("tasks") && (
          <>
            <Header>Tasks</Header>
            <Card.Group>
              <StatCard
                label="Overdue"
                value={insightsQuery.data?.data?.data.tasks.overdue_count}
                colour={colours.blue}
                loading={insightsQuery.isFetching}
              />
              <StatCard
                label="Due Today"
                value={insightsQuery.data?.data?.data.tasks.today_count}
                colour={colours.blue}
                loading={insightsQuery.isFetching}
              />
              <StatCard
                label="Unscheduled"
                value={insightsQuery.data?.data?.data.tasks.unscheduled_count}
                colour={colours.blue}
                loading={insightsQuery.isFetching}
              />
            </Card.Group>
          </>
        )}
      </Segment>

      <Segment basic>
        {!insightsQuery.isFetching && (
          <small>
            Call data refreshed at {getUpdatedAt()}, other data refreshed at{" "}
            {insightsQuery.data?.data?.data.refreshed_at}
          </small>
        )}
      </Segment>

      {insightsQuery.isFetching && <Loader active inline="centered" />}
    </Container>
  );
}

export default Insights;
